import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface DownloadIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const DownloadIcon = ({ className, ...props }: DownloadIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 17L19 20C19 20 10.4673 20 5 20L5 17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 4V16M12 16L15.5 12.5M12 16L8.5 12.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default DownloadIcon;
